import React, { useState } from "react";
import Style from './OrdersAccardion.module.scss'
import { BasketFill, ChevronLeft } from "react-bootstrap-icons";
import AccardionItemPeyk from "../AccardionItemPeyk/AccardionItemPeyk";
const OrdersAccardion = () => {
  const [openOnClick, setOpenOnClick] = useState(false);
  const OrderItem = [
    {
      id: "6",
      title: "همه",
      link: "/allorderbuy",
      active: window.location.pathname === "/allorderbuy",
    },
    {
      id: "1",
      title: "فعال",
      link: "/activeorderbuy",
      active: window.location.pathname === "/activeorderbuy",
    },
    {
      id: "2",
      title: "قبول شده توسط تامین کننده",
      link: "/acceptedordersupplierbuy",
      active: window.location.pathname === "/acceptedordersupplierbuy",
    },
    {
      id: "3",
      title: "قبول شده توسط پیک",
      link: "/acceptedorderdeliverybuy",
      active: window.location.pathname === "/acceptedorderdeliverybuy",
    },
    {
      id: "4",
      title: "آماده شده",
      link: "/preparedorderbuy",
      active: window.location.pathname === "/preparedorderbuy",
    },
    {
      id: "5",
      title: "تحویل داده شده",
      link: "/ordersdeliveredbuy",
      active: window.location.pathname === "/ordersdeliveredbuy",
    },
  ];
  let value = false;
  OrderItem.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });
  const openHandler = () => {
    if (openOnClick) {
      setOpenOnClick(false);
    } else {
      setOpenOnClick(true);
    }
  };
  return (
    <div className={Style.accardionChild}>
      <div
        className={
          value || openOnClick ? Style.background : Style.accardionTitle
        }
        onClick={openHandler}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}>سفارشات</p>
          <BasketFill />
        </div>
      </div>
      {OrderItem === undefined ? null : (
        <div
          className={
            value || openOnClick ? Style.accardionContent : Style.hidden
          }
        >
          <AccardionItemPeyk accardonItem={OrderItem && OrderItem} />
        </div>
      )}
    </div>
  );
};

export default OrdersAccardion;
